export default {"src":"/_next/static/media/arrow-down.93a7c3bb.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};